enum MapLayerType {
    /// <summary>
    /// OpenStreetMap TileLayer (tile.openstreetmap.org)
    /// </summary>
    OSM = 0,
  
    /**
     * Esri World_Topo_Map TileLayer (World_Topo_Map/MapServer/tile)
     */
    EsriWorldTopoMap,
  
    /**
     * Esri World_Imagery TileLayer (World_Imagery/MapServer/tile)
     */
    EsriWorldImagery,
  
    /**
     * USGS Topo TileLayer (USGSTopo/MapServer/tile)
     */
    USGSTopo,
  
    /**
     * ReportAll Parcel TileLayer
     */
    ReportAllParcel,

    /**
     * Esri World Hillshade
     */
    EsriWorldHillshade,

    

    USDANAIP,

    /**
     *  Orthoimagery collected in Spring 2017, 2018 and 2019 (whichever is most recently available) by the VBMP program for Virginia. The imagery is displayed in true color (RED, GREEN, BLUE). The spatial reference is WGS 1984 Web Mercator (Auxiliary Sphere). The imagery is tiled at 12 levels from 1:4,622,324 to 1:1,128. The imagery was collected to meet ASPRS Class 1 orthoimagery standards. Most areas were collected at a 1-ft ground sample distance (GSD), with some urban areas upgraded to 6-inch and 3-inch GSD. - "Any determination of topography or contours, or any depiction of physical improvements, property lines or boundaries is for general information only and shall not be used for the design, modification, or construction of improvements to real property or for flood plain determination." Subsection C of § 54.1-402.
     */
    VAMostRecentImagery,

    /**
     * National Hydrography Dataset (NHD) 
     * Layer: Flowline - Small Scale (ID: 5)     * 
     * https://hydro.nationalmap.gov/arcgis/rest/services/nhd/MapServer/5
     * 
     */
    NationalMapNHDFlowLinesSmallScale,


    GoogleHybrid,

    HEREAerialStreetTile,

    /**
     * HERE Terrain Map - https://developer.here.com/documentation/map-tile/dev_guide/topics/example-terrain-map.html
     * Example: https://1.aerial.maps.ls.hereapi.com/maptile/2.1/maptile/newest/terrain.day/7/66/45/256/png8?apiKey={YOUR_API_KEY}
     */
    HERETerrainDay,

    /**
     * Esri USA Major Cities Map Server Layer: 
     * https://services.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/USA_Major_Cities/FeatureServer/0/query?where=%28ST%3D%27VA%27+OR+ST%3D%27NC%27+OR+ST%3D%27SC%27%29+AND+CLASS%3D%27city%27&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&returnGeodetic=false&outFields=NAME%2CST&returnGeometry=true&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pgeojson&token=
     */
    EsriUSAMajorCities


    
  }

    // tslint:disable-next-line: no-default-export
    export default MapLayerType;